import React, { useEffect, useState } from 'react';
import Navbar from './Navbar'; 
import './App.css'; 
import ImageGallery from './ImageGallery';
import logo from './img/logo8.png';
import loadingGif from './img/loading.gif';
import Afraid from './img/Illustration/afraid.jpg';
import Crow from './img/Illustration/crow.jpg';
import Requiem from './img/Illustration/requiem.jpg';
import Athena from './img/Illustration/athena-cover.jpg';
import Curio from './img/Illustration/curio.jpg';
import Scopsfun from './img/Illustration/scopsfun.jpg';
import Tavsi from './img/Illustration/tavsi.jpg';
import Ache from './img/Illustration/acheinsecret.jpg';
import Wattlebird from './img/Illustration/wattlebird.jpg'
import Waltz from './img/Illustration/waltz.jpg'
import Car from './img/Illustration/car_i.jpg'
import Nau from './img/Illustration/nau.jpg'
import Story from './img/Illustration/story_i.jpg'
import Self from './img/Illustration/self.jpg'
import Tears from './img/Illustration/tears.jpg'
import Key from './img/Illustration/keycover.jpg'
import Showroom from './img/Illustration/showroomcover.jpg'
import Sketches from './img/Illustration/sketches.jpg'
import Contact from './Contact'
import Design from './Design';

import Studio from './Studio';

import About from './image/About'
import { BrowserRouter as Router, Route, Routes, Link, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import RightSidebar from './RightSidebar';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"
import BirdDetail from './image/WattlebirdDetail';
import CarDetail from './image/CarDetail';
import CrowDetail from './image/CrowDetail';
import RequiemDetail from './image/RequiemDetail';
import StoryDetail from './image/StoryDetail';
import TavsiDetail from './image/TavsiDetail';
import TearsDetail from './image/TearsDetail';
import WaltzDetail from './image/WaltzDetail';
import CampusDetail from './image/CampusDetail';
import AccessoDetail from './image/AccessoDetail';
import AcheInSecretDetail from './image/AcheInSecretDetail';
import AfraidDetail from './image/AfraidDetail';
import AwakenDetail from './image/AwakenDetail';
import BoxDesignDetail from './image/BoxDesignDetail';
import NauDetail from './image/NauDetail';
import ScopsFunDetail from './image/ScopsFunDetail';
import PortraitDetail from './image/SelfDetail';
import SocialDetail from './image/SocialDetail';
import GameDetail from './image/GameDetail';
import AthenaDetail from './image/AthenaDetail';
import BibimcosDetail from './image/BibimcosDetail';
import BibimcosanDetail from './image/BibimcosanDetail';
import CurioDetail from './image/CurioDetail';
import MjcareDetail from './image/MjcareDetail';
import SamsungDetail from './image/SamsungDetail';
import NovaDetail from './image/NovaDetail';
import CleanerDetail from './image/CleanerDetail';
import NewYearDetail from './image/NewYearDetail';
import SoraDetail from './image/SoraDetail';
import LinoDetail from './image/LinoDetail';
import MindDetail from './image/MindDetail';
import ValentineDetail from './image/ValentineDetail';
import ShowroomDetail from './image/ShowroomDetail';
import PlasticDetail from './image/PlasticDetail';
import WatsonsDetail from './image/WatsonsDetail';
import SquareDetail from './image/SquareDetail';
import UnfollowersDetail from './image/UnfollowersDetail';
import KeyDetail from './image/KeyDetail';
import SketchesDetail from './image/SketchesDetail';
const images = [
  { src: Key, alt: 'Artist Artwork'},
  { src: Curio, alt: 'book illustration'},
  { src: Athena, alt: 'Album Cover Design'},
  { src: Crow, alt: 'NFT.NYC2024'},
  { src: Sketches, alt: 'Sketches/Ongoing Projects'},
  { src: Showroom, alt: 'Showroom Spatial Brand Experience'},
  { src: Requiem, alt: 'Requiem'},
  { src: Ache, alt: 'Ache in Secret'},
  { src: Afraid, alt: 'Afraid'},
  { src: Tavsi, alt: 'Echoes of Existence'},
  { src: Wattlebird, alt: 'hear my soul speak.'},
  { src: Scopsfun, alt: 'longboard design'},
  { src: Car, alt: 'the Black Cat'},
  { src: Self, alt: 'some portraits', title: 'Portraits'},
  { src: Nau, alt: 'concept art'},
  { src: Story, alt: 'the NeverEnding Story'},
  { src: Tears, alt: 'Tears'},
  
  
];



function AppContent() {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);

    const imagesOnPage = Array.from(document.images);
    if (imagesOnPage.length === 0) {
      setIsLoading(false);
      return undefined;
    }

    let remaining = imagesOnPage.length;
    const markLoaded = () => {
      remaining -= 1;
      if (!cancelled && remaining <= 0) {
        setIsLoading(false);
      }
    };

    imagesOnPage.forEach((img) => {
      if (img.complete && img.naturalWidth !== 0) {
        markLoaded();
        return;
      }
      img.addEventListener('load', markLoaded, { once: true });
      img.addEventListener('error', markLoaded, { once: true });
    });

    return () => {
      cancelled = true;
      imagesOnPage.forEach((img) => {
        img.removeEventListener('load', markLoaded);
        img.removeEventListener('error', markLoaded);
      });
    };
  }, [location.pathname]);

  return (
    <div className="App">
      {isLoading && (
        <div className="page-loader" role="status" aria-live="polite">
          <img src={loadingGif} alt="Loading" />
        </div>
      )}
      <header className="App-header">
        <SpeedInsights/>
        <Analytics/>
        <Link to="/">
          <img src={logo} alt="Logo" className="App-logo" />
        </Link>
        <Navbar />
      </header>
      <Sidebar />
      <RightSidebar />
      <Routes>
        <Route path="/" element={
          <div className='content'>
            <ImageGallery images={images} />
          </div>
        } />
        <Route path="/contact" element={<Contact />} />
        <Route path="/design" element={<Design />} />
        <Route path="/studio" element={<Studio />} />
        <Route path="/about" element={<About />} />
        <Route path="/image/hear my soul speak." element={<BirdDetail />} />
        <Route path="/image/the Black Cat" element={<CarDetail />} />
        <Route path="/image/NFT.NYC2024" element={<CrowDetail />} />
        <Route path="/image/Sketches/Ongoing Projects" element={<SketchesDetail />} />
        <Route path="/image/requiem" element={<RequiemDetail />} />
        <Route path="/image/the NeverEnding Story" element={<StoryDetail />} />
        <Route path="/image/echoes of existence" element={<TavsiDetail />} />
        <Route path="/image/tears" element={<TearsDetail />} />
        <Route path="/image/the ethereal waltz" element={<WaltzDetail />} />
        <Route path="/image/Promotional Design" element={<CampusDetail />} />
        <Route path="/image/Brand Identity" element={<AccessoDetail />} />
        <Route path="/image/ache in secret" element={<AcheInSecretDetail />} />
        <Route path="/image/afraid" element={<AfraidDetail />} />
        <Route path="/image/Awaken Identity Design" element={<AwakenDetail />} />
        <Route path="/image/box design" element={<BoxDesignDetail />} />
        <Route path="/image/concept art" element={<NauDetail />} />
        <Route path="/image/longboard design" element={<ScopsFunDetail />} />
        <Route path="/image/some portraits" element={<PortraitDetail />} />
        <Route path="/image/Social Media 2022-2026" element={<SocialDetail />} />
        <Route path="/image/Concept Game Design" element={<GameDetail />} />
        <Route path="/image/Album Cover Design" element={<AthenaDetail />} />
        <Route path="/image/Promotional Design 02" element={<BibimcosDetail />} />
        <Route path="/image/Bibimcosan" element={<BibimcosanDetail />} />
        <Route path="/image/Visual Identity and Campaign Design" element={<BibimcosanDetail />} />
        <Route path="/image/book illustration" element={<CurioDetail />} />
        <Route path="/image/Outdoor AD" element={<MjcareDetail />} />
        <Route path="/image/Flyer Design" element={<SamsungDetail />} />
        <Route path="/image/Brand Identity Design" element={<NovaDetail />} />
        <Route path="/image/UI UX Design and Brand Identity" element={<CleanerDetail />} />
        <Route path="/image/New Year Concept" element={<NewYearDetail />} />
        <Route path="/image/AI Visuals" element={<SoraDetail />} />
        <Route path="/image/Carve Ink Press" element={<LinoDetail />} />
        <Route path="/image/Acrylic on Canvas" element={<MindDetail />} />
        <Route path="/image/Valentine's Day" element={<ValentineDetail />} />
        <Route path="/image/Showroom Spatial Brand Experience" element={<ShowroomDetail />} />
        <Route path="/image/Event Space Design Plastic Free Festival" element={<PlasticDetail />} />
        <Route path="/image/Watsons X MJCare Collaboration" element={<WatsonsDetail />} />
        <Route path="/image/Square! Game Design" element={<SquareDetail />} />
        <Route path="/image/Mobile App Brand Identity and UI UX" element={<UnfollowersDetail />} />
        <Route path="/image/Artist Artwork" element={<KeyDetail />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}


export default App;
